import React from "react";
import PropTypes from "prop-types";
import Text from "@/bit/components/components.text";

export const COMPONENT_NAME = "TextBlockItem";

const TextBlockItem = (props) => {
  const {
    cmsHandler,
    blockName,
    alias,
    index,
    frontalListToDelete,
    CmsEditableGroupIcons,
  } = props;

  return (
    <>
      <div className="text-block-item">
        {/* Bolitas de edicion aqui */}
        {CmsEditableGroupIcons && (
          <CmsEditableGroupIcons
            elementProps={{
              ...props,
              editName: "cms-block.text-block-item",
            }}
            deleteProps={{
              index,
              itemIdDotNotation: `${blockName}.cms-ml-single-text-block-list`,
              alias,
              frontalListToDelete: frontalListToDelete,
            }}
            visibleTools={{
              hiring: false,
              edit: true,
              deleteItem: true,
            }}
            cmsHandler={cmsHandler}
          />
        )}
        <Text
          key={index}
          {...props["cms-atom-text-1"]}
          cmsHandler={cmsHandler}
        />
      </div>

      <style jsx>{`.text-block-item {
  position: relative;
  &--with-borders {
    border: 1px solid #eeeeee;
  }

  &--with-bottom-border {
    border-bottom: 1px solid #eeeeee;

    &:hover {
      background-color: #f5f5f5;
    }
  }
}
`}</style>
    </>
  );
};

TextBlockItem.propTypes = {
  /**
   * {
   *  "info": "Identificador para poder filtrar y ordenar en caliente (config)",
   *  "kind": "both",
   *  "beautifulName": "Identificador"
   * }
   */
  id: PropTypes.string,
};

TextBlockItem.defaultProps = {
  id: "",
};

export default TextBlockItem;
